import React, { Suspense, useState, useContext, useEffect } from 'react'
import { HashRouter, Route, Routes, Navigate } from 'react-router-dom'
import './scss/style.scss'
import '../src/Styles/style.css'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import "react-datepicker/dist/react-datepicker.css";
import loadGif from './assets/uedu_load_gif.gif'
import { GlobalContext } from './context'
import GlobalProvider from './context'
import { encyptedData, decryptedData } from './views/Access'
import AppRoutes from './AppRoutes'
import './Responsive.css'
import 'react-modern-drawer/dist/index.css'

const loading = (
  <div
    style={{
      width: '100vw',
      height: '100vh',
      justifyContent: 'center',
      alignItems: 'center',
    }}
    className="d-flex sk-double-bounce"
  >
    <div
      style={{
        marginTop: '-4%',
      }}
      className="d-flex flex-column"
    >
      {/* <div className="d-flex justify-content-center"> */}
        {/* <img
          style={{ objectFit: 'contain', width: "30%" }}
          src={loadGif}
        /> */}
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.6)',
            zIndex: 9999,
          }}
        >
          <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      {/* </div> */}
    </div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
// const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

// const AppRoutes = () => {
//   // const navigate = useNavigate()
//   const { state, dispatch } = useContext(GlobalContext)
//   const { isAuthenticated } = state
//   console.log(isAuthenticated, 'isAuthenticated')

//   const parseJwt = (token) => {
//     try {
//       return JSON.parse(atob(token.split('.')[1]))
//     } catch (e) {
//       return null
//     }
//   }

//   const fetchData = async () => {
//     const userData = await localStorage.getItem('USERDATA')
//     const userToken = await localStorage.getItem('USERTOKEN')

//     if (userData && userToken) {
//       const decryptuserData = decryptedData(userData)
//       const decryptuserToken = decryptedData(userToken)
//       const decodedJwt = parseJwt(decryptuserToken)
//       if (decodedJwt.exp * 1000 < Date.now()) {
//         dispatch({
//           type: 'LOGOUT',
//         })
//         toast.error('Session has been expired, Please login again')
//         Navigate('/login')
//       } else {
//         dispatch({
//           type: 'PROFILE',
//           payload: { ...decryptuserData, userToken: decryptuserToken },
//         })
//       }
//     } else {
//       dispatch({
//         type: 'LOGOUT',
//       })
//       Navigate('/login')
//     }
//   }

//   useEffect(() => {
//     fetchData()
//   }, [])

//   return (
//     <React.Fragment>
//       <ToastContainer />
//       <HashRouter>
//         <Suspense fallback={loading}>
//           {isAuthenticated ? (
//             <Routes>
//               <Route exact path="/login" name="Login Page" element={<Navigate to={'/'} />} />
//               <Route path="*" name="Home" element={<DefaultLayout />} />
//             </Routes>
//           ) : (
//             <Routes>
//               <Route exact path="/" name="Login" element={<Login />} />
//               <Route exact path="/login" name="Login Page" element={<Login />} />
//               {/* <Route exact path="/register" name="Register Page" element={<Register />} /> */}
//               <Route exact path="/404" name="Page 404" element={<Page404 />} />
//               <Route exact path="/500" name="Page 500" element={<Page500 />} />
//               <Route exact path="*" name="Page 500" element={<Page404 />} />
//             </Routes>
//           )}
//         </Suspense>
//       </HashRouter>
//     </React.Fragment>
//   )
// }

function App() {
  return (
    <GlobalProvider>
      <AppRoutes />
    </GlobalProvider>
  )
}

export default App
